import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';
import { ROCELL_COLORS } from '../theme/rocellTheme';

export class TripCostchart extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "pie"
                },
                labels: ['Single trip cost', 'Couple trip cost', 'Profit'],
                legend: { position: 'bottom' },
            },
            series: [],
            isLoaded: false,
            filterDateTo: '',
            shipments:[]
        };

        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(data) {
        this.setState((prevState) => ({
            series: data
        }));
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        }
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_tcs"

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                console.log(response.data.data);
                const dataArray = [Math.round(response.data.data.single_trip_cost), Math.round(response.data.data.couplt_trip_cost), Math.round(response.data.data.profit)]
                console.log(dataArray)
                const shipment_data = response.data.shipment_wise_cost;
                this.setState({shipments:shipment_data})
                this.setState({ series: [] })
                this.setState({
                    options: {
                        chart: { type: "pie" }, labels: ['Single trip cost', 'Couple trip cost', 'Profit'], legend: { position: 'bottom' },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val, opts) {
                                let total = opts.w.config.series[opts.seriesIndex];
                                return `${val.toFixed(1)}% (Rs.${total}/=)`;
                            },
                        }
                    }
                })

                this.updateState(dataArray)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const formData = new FormData();
        formData.append('filter_date', newToDate);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();

        var currentDate = new Date();
        var currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDate = currentDate.toISOString().split('T')[0];

        formData.append('filter_date', formattedDate);
        this.setState({ filterDateTo: formattedDate })
        this.getData(formData);
    }

    formatCurrency(amount) {
        const formattedAmount = new Intl.NumberFormat('en-IN').format(amount);
        return `Rs.${formattedAmount}/=`;
    }

    render() {
        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    Trip Cost Saving
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDateTo}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-7 bi-chart-actions mt-3 mt-lg-0'>
                            <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'>
                                <i className='fas fa-filter me-1'></i> Filter
                            </button>
                            <ExcelExport data={this.state.shipments} fileName="Trip Cost Saving" />

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row g-4'>
                        <div className='col-12 col-lg-7'>
                            <div className='bi-chart-area'>
                                {!this.state.isLoaded ? (
                                    <Circles
                                        height="80"
                                        width="80"
                                        color={ROCELL_COLORS.primary}
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                ) : (
                                    <Chart
                                        options={this.state.options}
                                        series={this.state.series}
                                        type="pie"
                                        width="100%"
                                        height="100%"
                                    />
                                )}
                            </div>
                        </div>
                        <div className='col-12 col-lg-5'>
                            <div className='bi-table-scroll'>
                                <table className='table table-bordered bi-data-table'>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Shipment #</th>
                                            <th>Outcome Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.shipments.map((record) => (
                                        <tr key={record.shipment_number}>
                                            <td>{record.date}</td>
                                            <td>{record.shipment}</td>
                                            <td>{(()=>{
                                                return this.formatCurrency(record.profit)
                                            })()}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}